import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Whoa",
  "description": "",
  "published": "2006-06-10T00:00:00.000Z",
  "redirect_from": ["/blog/whoa/swizec/404"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Yesterday as I was going home from... somewhere... I saw two dudes arguing over a minor collision of their cars, a white Ford and a darkish something if I recall correctly, I thought to myself, heh they're my age group. Then it hit me. Even only a year ago I would have thought that they are old geezers compared to me. Is it reall happening? Am I really getting old? I don't want to be old, this is damn scary.`}</p>
    <p>{`Anyway, now that I'm a scared old bastard, this apparently does not mean that I am any the wiser or anything like that, mainly so because I spent a good part of the last two days reading through `}<a parentName="p" {...{
        "href": "http://www.reallifecomics.com"
      }}>{`these archives`}</a>{` and not working on the comic at all. That's right folks, not even a single line of it has been drawn, which means that the update is not really due any minute as was expected but rather... postponed indefinitely. Sure, it will by "on time" as it will be in the month of June, but when in the month of June noone can predict, hopefully very soon.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      